import{__exports as n}from"../../../_virtual/scheduler-tracing.production.min.js";export{__exports as default}from"../../../_virtual/scheduler-tracing.production.min.js";
/** @license React v0.19.1
 * scheduler-tracing.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var r=0;n.__interactionsRef=null,n.__subscriberRef=null,n.unstable_clear=function(n){return n()},n.unstable_getCurrent=function(){return null},n.unstable_getThreadID=function(){return++r},n.unstable_subscribe=function(){},n.unstable_trace=function(n,r,t){return t()},n.unstable_unsubscribe=function(){},n.unstable_wrap=function(n){return n};
//# sourceMappingURL=scheduler-tracing.production.min.js.map
